import '@/shared/tokens/widgets.css';

import { registerAdipaFormWidget } from '@/features/forms/element/register-adipa-form-widget';
import { registerNewsletterWidget } from '@/features/forms/element/register-newsletter-widget';
import { registerCartSheetWidget } from '@/features/cart/element/register-cart-sheet-widget';
import { registerCartButtonWidget } from '@/features/cart-button/element/register-cart-button-widget';
import { registerCourseCardWidget } from '@/features/course-card/element/register-course-card-widget';
import { registerFavoriteButtonWidget } from '@/features/favorite-button/element/register-favorite-button-widget';
import { registerFooterWidget } from '@/features/footer/element/register-footer-widget';
import { registerNavbarWidget } from '@/features/navbar/element/register-navbar-widget';
import { registerSearchBarWidget } from '@/features/search-bar/element/register-search-bar-widget';
import { registerUserMenuWidget } from '@/features/user-menu/element/register-user-menu-widget';

const registerNavigationWidgets = () => {
  registerNavbarWidget();
  registerCartSheetWidget();
  registerSearchBarWidget();
  registerUserMenuWidget();
  registerCourseCardWidget();
  registerCartButtonWidget();
  registerFavoriteButtonWidget();
  registerFooterWidget();
  registerNewsletterWidget();
  registerAdipaFormWidget();
};

registerNavigationWidgets();

declare global {
  interface Window {
    AdipaWidgets?: Record<string, unknown>;
  }
}

if (typeof window !== 'undefined') {
  window.AdipaWidgets = {
    ...(window.AdipaWidgets ?? {}),
    registerNavigationWidgets,
    registerAdipaFormWidget,
    registerNavbarWidget,
    registerCartSheetWidget,
    registerCartButtonWidget,
    registerCourseCardWidget,
    registerFavoriteButtonWidget,
    registerFooterWidget,
    registerNewsletterWidget,
    registerSearchBarWidget,
    registerUserMenuWidget,
  };
}
